import React from 'react';
import styled from '@emotion/styled';
import { height, minHeight, minWidth, space, width } from 'styled-system';

import { StateType } from '../../../enums/StateType';
import type { SpaceProps } from '../../../theme/system-types';
import { fill } from '../../../theme/system-utilities';
import Icon from '../../Icon';
import { ThemeTextColor } from './enums';

interface StateIconProps extends SpaceProps {
  type: StateType;
  size?: number;
  className?: string;
}

const DEFAULT_SIZE = 24;

const StyledIcon = styled(Icon)<any>`
  ${space};
  ${width};
  ${height};
  ${minWidth};
  ${minHeight};
  ${fill};
`;

const getColorValue = (type: StateType) => {
  switch (type) {
    case StateType.Error:
      return ThemeTextColor.Error;
    case StateType.Warning:
      return ThemeTextColor.Warning;
    case StateType.Success:
      return ThemeTextColor.Success;
    case StateType.Loading:
      return ThemeTextColor.Active;
  }
};

const getIconStyleProps = (type: StateType) => {
  return { fill: getColorValue(type) };
};

const StateIcon = ({ type, size = DEFAULT_SIZE, className, ...spaceProps }: StateIconProps) => {
  const sizeProps = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
  };

  return (
    <StyledIcon
      name={type}
      className={className}
      {...sizeProps}
      {...spaceProps}
      {...getIconStyleProps(type)}
    />
  );
};

export default StateIcon;
